import { render, staticRenderFns } from "./events-auth.vue?vue&type=template&id=58f413e4"
import script from "./events-auth.vue?vue&type=script&lang=js"
export * from "./events-auth.vue?vue&type=script&lang=js"
import style0 from "./events-auth.vue?vue&type=style&index=0&id=58f413e4&prod&lang=scss"


/* normalize component */
import normalizer from "!../node_modules/.pnpm/vue-loader@15.11.1_babel-core@7.0.0-bridge.0_@babel+core@7.27.1__cache-loader@4.1.0_web_7b61c9c1aec7d7f161a598a5137052ac/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports